import {BaseDashlet} from "../../lq_js_common/dashboard/base_dashlet";
import {DashboardGraph} from "../../graphs/dashboard_graph";
import {GraphOptionsBuilder} from "../../lq_js_common/e_charts/chart_builder";
import {MinMaxSeries} from "../../lq_js_common/e_charts/min_max_median_series";
import {createBoundedAxisTooltip, formatMillisecondsAxis, formatTimeTick} from "../../helpers/chart_common";

export class ShaperRtt extends BaseDashlet {
    constructor(slot) {
        super(slot);
        this.rendered = false;
        this.lastGraphState = null;
    }

    title() {
        return "Shaper Round-Trip Time";
    }

    supportsZoom() {
        return true;
    }

    tooltip() {
        return "<h5>Shaper Round-Trip Time</h5><p>Shows the average round-trip time for the shaper in the selected time period.</p>";
    }

    buildContainer() {
        let base = super.buildContainer();
        base.appendChild(this.graphDiv());
        return base;
    }

    setup() {
        super.setup();
        this.graph = new ShaperRttGraph(this.graphDivId());
        if (this.lastGraphState !== null) {
            this.graph.update(this.lastGraphState);
        }
    }

    channelRequests() {
        return [ "ShaperDetail" ];
    }

    onMessage(msg) {
        if (msg.Data.target !== "shaper_detail") return;

        if (!this.rendered) {
            let myDiv = document.getElementById(this.id);
            myDiv.classList.add("card", "animate__animated", "animate__fadeIn");
        } else {
            let myDiv = document.getElementById(this.id);
            myDiv.classList.add("animate__animated", "animate__pulse");
            setTimeout(() => {
                myDiv.classList.remove("animate__animated", "animate__pulse");
            }, 1000);
        }
        for (const [key, value] of Object.entries(msg.Data.blob)) {
            this.graph.update(value);
            this.lastGraphState = value;
        }
    }

}

class ShaperRttGraph extends DashboardGraph {
    constructor(id) {
        super(id);
        this.option = new GraphOptionsBuilder()
            .withLeftGridSize(75)
            .withTimeAxis()
            .withEmptyLegend()
            .withEmptySeries()
            .build();
        this.option.yAxis = {
            type: "value",
            name: "RTT (ms)",
            nameLocation: "middle",
            nameGap: 50,
            axisLabel: {
                formatter: formatMillisecondsAxis,
            },
        };
        this.option && this.chart.setOption(this.option);
    }

    update(data) {
        this.chart.hideLoading();

        this.option.series = [];
        this.option.xAxis.data = [];
        this.option.legend = { show: false, data: [] };


        // Add series for each shaper
        let d = new MinMaxSeries("RTT", 0);
        for (let x=0; x<data.body.active_circuits.length; x++) {
            this.option.xAxis.data.push(data.body.ticks[x]);
            d.pushPositive(
                data.body.rtt_median[x]/10,
                data.body.rtt_min[x]/10,
                data.body.rtt_max[x]/10,
            )
        }
        d.addToOptions(this.option);

        this.option.tooltip = createBoundedAxisTooltip({
            yFormatter: formatMillisecondsAxis,
            formatter: (params) => {
                if (!params || params.length === 0) return "";
                const timeIndex = params[0].dataIndex;
                const rttMin = data.body.rtt_min[timeIndex] / 10;
                const rttMedian = data.body.rtt_median[timeIndex] / 10;
                const rttMax = data.body.rtt_max[timeIndex] / 10;
                return `<div style="font-size: 10px;">
${formatTimeTick(params[0].axisValue)}<br/>
<strong>Round-trip time</strong><br/>
&nbsp;&nbsp;Min: ${formatMillisecondsAxis(rttMin)}<br/>
&nbsp;&nbsp;Median: ${formatMillisecondsAxis(rttMedian)}<br/>
&nbsp;&nbsp;Max: ${formatMillisecondsAxis(rttMax)}
</div>`;
            },
        });

        // Add axis pointer configuration for highlighting
        this.option.axisPointer = {
            link: {xAxisIndex: 'all'},
            label: {
                backgroundColor: 'rgba(30,30,30,0.92)',
                color: '#fff',
                fontFamily: 'inherit'
            }
        };

        // Apply
        this.chart.setOption(this.option, true);
    }
}
